import { removeUserFromLocalStorage } from "../functions/localStorageManager";
import { useNavigate } from "react-router-dom";
import { loadingState, loadingText } from "../states/loadingState";
import { userState } from "../states/userState";
import { auth } from "../firebase";
import { useSetRecoilState, useRecoilState, useResetRecoilState } from "recoil";

export const useLogout = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);
  const navigation = useNavigate();
  const resetUserState = useResetRecoilState(userState);
  const [user, setUser] = useRecoilState(userState);
  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));
  const logoutFromGoogleWithResetCache = async () => {
    setLoadingAnimation(true);
    navigation("/login");
    // console.log("logout");
    setLoadingText("ログアウト中...");
    //setUserToLocalStorage({ ...user, isAuth: false });
    removeUserFromLocalStorage();
    //return;
    setUser({ ...user, isAuth: false });
    resetUserState();
    await sleep(400);
    auth
      .signOut()
      .then(() => {
        setLoadingAnimation(false);
        setLoadingText("");
        window.location.reload();
      })
      .catch((error) => {
        // サインアウト中のエラーをここで扱う
        console.error("サインアウトエラー: ", error);
        setLoadingAnimation(false);
        setLoadingText("");
      });
  };

  return {
    logoutFromGoogleWithResetCache,
  };
};
